<template>
    <div>
        <b-button :variant="btn_variant" :class="d_none" :disabled="disabled" @click.stop="printStart">
            <slot></slot>
        </b-button>

        <b-modal :id="'print_modal'+modal_id" size="lg" title="인쇄/다운로드" hide-footer @show="handleShow()" @hide="handleClose()">
            <div class="d-block text-center">
                <p class="text-left fw-500"> {{$t(`PDF로 다운로드 하실 경우 아래 설명을 확인 후 진행해 주세요.`)}}</p>

                <b-tabs content-class="bg-white pt-3 pb-4 mb-4">
                    <b-tab :title="$t(`크롬(Google Chrome) 사용중인 경우`)" active>
                        <b-img :src="$i18n.locale=='en'?'/images/how_to_print_chrome_en.png':'/images/how_to_print_chrome.png'" :alt="$t('인쇄 창에서 대상을 PDF로 저장, 여백을 없음으로 고르고 배경 그래픽을 체크한 뒤 저장을 누르는 화면')" fluid style="max-width: 90%"></b-img>
                    </b-tab>
                    <b-tab :title="$t(`엣지(Microsoft Edge) 사용중인 경우`)">
                        <b-img :src="$i18n.locale=='en'?'/images/how_to_print_edge_en.png':'/images/how_to_print_edge.png'" :alt="$t('인쇄 창에서 대상을 PDF로 저장, 여백을 없음으로 고르고 배경 그래픽을 체크한 뒤 저장을 누르는 화면')" fluid style="max-width: 90%"></b-img>
                    </b-tab>
                </b-tabs>
                <!-- popTitle 은 인쇄 창 제목 = PDF 저장 시 기본 파일명. 비우면 print.js 가 화면 제목을 쓴다 -->
                <b-button v-print="{id: print_target, popTitle: file_title || undefined}" variant="blue">PDF 인쇄 / 다운로드</b-button>
            </div>
            <b-button class="float-right" variant="dark" @click="cancel()">취소</b-button>
        </b-modal>
    </div>
</template>
<script>
// IE 지원 종료(browser-support-guide)로 IE 전용 PDF 생성 경로(html2canvas·jsPDF)는 없앴다 — 모든 브라우저가 인쇄 창으로 저장한다.
export default {
    name: 'pdf',
    props:{
        print_target: {
            type: String,
            required: true
        },
        // PDF 기본 파일명(인쇄 창 제목). 예: '<업체명> 전문가 종합의견'
        file_title: {
            type: String,
            default: ''
        },
        btn_variant: {
            type: String,
            default: 'dark-border'
        },
        d_none: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            is_printing: false,
            modal_id: Math.random()*1000
        }
    },
    methods: {
        printStart () {
            this.$bvModal.show('print_modal'+this.modal_id)
        },
        cancel () {
            this.$bvModal.hide('print_modal'+this.modal_id)
        },
        handleShow () {
            this.is_printing = true
            this.$emit('modal-opened')
        },
        handleClose () {
            this.is_printing = false
            this.$emit('modal-closed')
        },
    },
}
</script>
